import React, { useContext } from 'react';
import { NewActionMenu, NewActionMenuItem } from "@app/shared/action-menu";
import html2canvas from 'html2canvas';
import { formatDateTime } from "@app/shared";
import { Features } from "@app/feature-flags";
import { FeatureFlagContext } from "@app/feature-flags/FeatureFlagContext";
import { renderToStaticMarkup } from 'react-dom/server';

interface MapExportProps {
  isLoading: boolean;
  specialty: string;
  serviceArea: string;
  runConfigurationDateCreated: Date;
  projectName: string;
}

const MapExport: React.FC<MapExportProps> = ({ isLoading, specialty, serviceArea, runConfigurationDateCreated, projectName }) => {

  const featureFlagProps = useContext(FeatureFlagContext);

  const exportMap = (showDetails: boolean) => {
    const titleDiv = getTitleDiv();
    const exportName = `Network Coverage Map ${serviceArea} ${specialty} ${projectName}${showDetails ? ' with Details' : ''}`; 
    const selector = featureFlagProps.enabledFeatureFlags.has((Features.PROVIDER_MEMBER_MAPS_V2)) ?
                    '.network-coverage-map__map-container' : 
                    '.provider-member-mapping__map-container'
    const exportDiv = document.querySelector(selector) as HTMLElement;

    html2canvas(exportDiv as HTMLElement, {
      ignoreElements: function (element) {
        return element.classList.contains("mapboxgl-ctrl-group") || (!showDetails && element.classList.contains("provider-member-mapping__map-details-container"));
      },
      onclone: (clonedDoc) => {
        const clonedExportDiv = clonedDoc.querySelector(selector) as HTMLElement;

        if (clonedExportDiv) {
          clonedExportDiv.className = featureFlagProps.enabledFeatureFlags.has(Features.PROVIDER_MEMBER_MAPS_V2) ? 
                                      'network-coverage-map__map-export-canvas-container' :
                                      'provider-member-mapping__map-export-canvas-container';
          clonedExportDiv.insertBefore(titleDiv, clonedExportDiv.firstChild);
        }
      },
      removeContainer: true,
      scale: 2

    }).then(exportCanvas => {
      const imgData = exportCanvas.toDataURL("image/png");

      const link = document.createElement('a');
      link.download = exportName;
      link.href = imgData;
      link.click();
    });
  };

  const getTitleDiv = () => {
    const output = document.createElement('a');
    output.innerHTML =
      renderToStaticMarkup(
        <div className='title-div'>
          <img className="title-image" src={`${window.customUIBaseUrl}/images/QuestAnalyticsLogo.png`} alt="Quest Analytics" role="img" id="logo" />
          <div className="text-container">
            <span className="title-text">Network Coverage Map of {specialty} for {serviceArea}</span>
            <span className="date-text">Map Created on: {new Date().toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' })}</span>
            <span className="date-text">Timeslice Date: {formatDateTime(runConfigurationDateCreated)}</span>
          </div>
        </div>
      );

    return output;
  }

  return (
    <div className="pull-right provider-member-mapping__export-dropdown" data-html2canvas-ignore="true">
      <NewActionMenu
        alignRight={true}
        buttonText="Export"
        testId="provider-member-mapping__export-dropdown"
        buttonClassNames="qes-button-primary"
        dropup={false}
        loading={isLoading}>
        <NewActionMenuItem
          display="Export map image"
          isSelected={false}
          key={1}
          onClick={() => exportMap(false)}
          testId="provider-member-mapping__export-dropdown-option1"
        />
        <NewActionMenuItem
          display="Export map image with details"
          isSelected={false}
          key={2}
          onClick={() => exportMap(true)}
          testId="provider-member-mapping__export-dropdown-option2"
        />
      </NewActionMenu>
    </div>
  );
};

export default MapExport;
